export function can(user, perm) {
  if (!user) return false;

  // superadmin / admin-all pattern (pokud ho chceš)
  if (user.is_superadmin === true) return true;

  const perms = user.permissions;
  if (!Array.isArray(perms)) return false;

  return perms.includes(perm);
}